import React, { useState, useEffect } from 'react';
import { getSupportSettings } from '../services/firestoreService';
import './WhatsAppFloat.css';

export const WhatsAppFloat = () => {
    const [whatsappNumber, setWhatsappNumber] = useState('');

    useEffect(() => {
        loadWhatsAppNumber();
    }, []);

    const loadWhatsAppNumber = async () => {
        try {
            const settings = await getSupportSettings();
            setWhatsappNumber(settings.whatsappNumber || '+919876543210');
        } catch (error) {
            console.error('Error loading WhatsApp number:', error);
            setWhatsappNumber('+919876543210');
        }
    };

    const openWhatsApp = () => {
        if (whatsappNumber) {
            const cleanNumber = whatsappNumber.replace(/[^0-9]/g, '');
            window.open(`https://wa.me/${cleanNumber}`, '_blank');
        }
    };

    if (!whatsappNumber) return null;

    return (
        <button className="whatsapp-float" onClick={openWhatsApp}>
            <svg viewBox="0 0 32 32" fill="currentColor">
                <path d="M16 0C7.164 0 0 7.164 0 16c0 2.832.748 5.484 2.048 7.78L.688 30.5l7.028-1.844A15.93 15.93 0 0016 32c8.836 0 16-7.164 16-16S24.836 0 16 0zm0 29.333c-2.456 0-4.764-.664-6.748-1.82l-.484-.288-5.02 1.316 1.34-4.892-.316-.5A13.29 13.29 0 012.667 16c0-7.364 5.97-13.333 13.333-13.333S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.308-9.98c-.4-.2-2.368-1.168-2.736-1.3-.368-.132-.636-.2-.904.2-.268.4-1.036 1.3-1.268 1.568-.232.268-.468.3-.868.1-.4-.2-1.688-.62-3.216-1.98-1.188-1.06-1.992-2.368-2.224-2.768-.232-.4-.024-.616.176-.816.18-.18.4-.468.6-.7.2-.232.268-.4.4-.668.132-.268.068-.5-.032-.7-.1-.2-.904-2.176-1.24-2.98-.328-.78-.66-.672-.904-.684-.232-.012-.5-.016-.768-.016s-.7.1-1.068.5c-.368.4-1.404 1.372-1.404 3.348s1.436 3.884 1.636 4.152c.2.268 2.832 4.324 6.86 6.064.96.416 1.708.664 2.292.848.964.308 1.84.264 2.532.16.772-.116 2.368-.968 2.7-1.904.332-.936.332-1.736.232-1.904-.1-.168-.368-.268-.768-.468z"/>
            </svg>
        </button>
    );
};
